import Vue from 'vue';
import VueWait from 'vue-wait';
import VueToast from 'vue-toast-notification';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import Root from './views/root/Root.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker'; // nobody knows what this does

import 'vue-toast-notification/dist/index.css';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';

import '@/global/feature.directive';
import '@/global/level.directive';
import '@/global/filters';
import '@/global/mixins';
import VueNativeNotification from 'vue-native-notification';

Vue.config.productionTip = false;

Vue.use(VueToast);
Vue.use(AirbnbStyleDatepicker);
Vue.use(VueWait);

Vue.use(VueNativeNotification);

new Vue({
  el: '#app',
  router: router,
  store: store,
  wait: new VueWait({
    accessorName: '$loading',
    useVuex: true,
    vuexModuleName: 'loading',
    directiveName: 'loading'
  }),
  render: h => h(Root),
  renderError(h, err) {
    return h('pre', { style: { color: 'red' } }, err.stack);
  }
});
